import { Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import { content } from '../AiInsights.content';
import { DeepDiveSection } from '../types';
import { MarkdownSection } from './MarkdownSection';

interface DeepDiveContentProps {
  sections: DeepDiveSection[];
}

/**
 * Displays deep dive analysis sections with detailed breakdowns
 */
export function DeepDiveContent({ sections }: DeepDiveContentProps) {
  const localizedContent = useContent(content);

  return (
    <div className="flex flex-col gap-4">
      {sections.map((item, index) => (
        <div className="flex flex-row gap-6" key={index}>
          <Typography weight="bold" size="large">
            {index + 1}.
          </Typography>
          <div className="flex flex-col">
            <Typography weight="bold" size="large" className="mb-2">
              {item.header}
            </Typography>
            <MarkdownSection
              title={localizedContent.overview}
              content={item.overview_paragraph}
            />
            <MarkdownSection
              title={localizedContent.whatThisMeans}
              content={item.what_this_means_paragraph}
            />
            <MarkdownSection
              title={localizedContent.whatToLookOutFor}
              content={item.what_to_look_out_for_paragraph}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
